/* eslint-disable jsx-a11y/alt-text */
import React from 'react'
import { Box, Typography } from '@mui/material'
const NoDataFound = () => {
    return (
        <>
            <Box sx={{display: 'flex' , justifyContent: 'center' , alignItems: 'center' , marginTop: '20px' , textAlign: 'center'}}>
                <Box>
                    <img src='assets/images/newimages/nodata.png'></img>
                     <Box sx={{marginTop: '20px'}}>
                    <Typography sx={{color: '#1A1F36' , fontSize: '22px' , fontWeight: '700'}}>
                        No active time off policies
                    </Typography>
                    <Typography sx={{color: '#373737' , fontSize: '13px' , fontWeight: '400'}}>
                        Set up automatic accrual policies to manage your team’s time off with ease.
                    </Typography>
                </Box>
                </Box>
               
            </Box>

        </>
    )
}

export default NoDataFound